module.exports = "/_next/static/images/game-3-fingerprint-part-3-wrong-red-39934eff32cb89f26326ca5d513b1a31.png";